"use strict";
// The first-party plugin catalog. Order matters only for legacy derived lists
// (INTEGRATIONS keeps today's order: email/password, then Google).
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PARTY_PLUGINS = void 0;
const auth_1 = require("./auth");
const forms_1 = require("./forms");
const funnels_1 = require("./funnels");
const payments_1 = require("./payments");
const shop_1 = require("./shop");
const growth_1 = require("./growth");
const marketing_1 = require("./marketing");
const marketplace_1 = require("./marketplace");
const automations_1 = require("./automations");
const data_1 = require("./data");
const blocks_1 = require("./blocks");
__exportStar(require("./auth"), exports);
__exportStar(require("./automations"), exports);
__exportStar(require("./blocks"), exports);
__exportStar(require("./data"), exports);
__exportStar(require("./forms"), exports);
__exportStar(require("./funnels"), exports);
__exportStar(require("./growth"), exports);
__exportStar(require("./marketing"), exports);
__exportStar(require("./marketplace"), exports);
__exportStar(require("./payments"), exports);
__exportStar(require("./shop"), exports);
exports.FIRST_PARTY_PLUGINS = [
    auth_1.AUTH_PLUGIN,
    auth_1.EMAIL_PASSWORD_AUTH_PLUGIN,
    auth_1.GOOGLE_AUTH_PLUGIN,
    forms_1.FORMS_PLUGIN,
    payments_1.PAYMENTS_PLUGIN,
    payments_1.STRIPE_PLUGIN,
    payments_1.RAZORPAY_PLUGIN,
    payments_1.UPI_PLUGIN,
    payments_1.CASH_ON_DELIVERY_PLUGIN,
    shop_1.SHOP_PLUGIN,
    shop_1.FLAT_SHIPPING_PLUGIN,
    shop_1.INCLUSIVE_TAX_PLUGIN,
    shop_1.SHOP_EMAILS_PLUGIN,
    funnels_1.FUNNELS_PLUGIN,
    marketing_1.MARKETING_PLUGIN,
    ...marketing_1.MARKETING_TAG_PLUGINS,
    marketing_1.SEARCH_CONSOLE_PLUGIN,
    marketing_1.WHATSAPP_CHAT_PLUGIN,
    growth_1.EMAIL_MARKETING_PLUGIN,
    growth_1.KLAVIYO_PLUGIN,
    growth_1.MAILCHIMP_PLUGIN,
    growth_1.BREVO_PLUGIN,
    growth_1.REVIEWS_PLUGIN,
    marketplace_1.MARKETPLACE_PLUGIN,
    automations_1.AUTOMATIONS_PLUGIN,
    data_1.DATA_PLUGIN,
    blocks_1.BLOCKS_PLUGIN,
];
